import React, { PureComponent } from 'react';
import CsvGenerator from './CsvGenerator';

class CsvDownload extends PureComponent {

    constructor(props) {
        super(props);

        this.download = this.download.bind(this);
    }

    download() {
        const g = new CsvGenerator(this.props.clientData);
        const csvContent = g.getCsvString();
        const a = document.createElement("a");
        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.setAttribute("download", "client_health.csv");
        a.click();
    }


    render() {

        return (
            <div className="download">
                <span className="fa fa-download icon-active" aria-hidden="true" onClick={this.download} />
            </div>
        );
    }
}

export default CsvDownload;


// WEBPACK FOOTER //
// ./src/CsvDownload.js